"use client";

function ModalPago({
  modalPago,
  setModalPago,
  handleUpdatePayment,
  isSaving,
  date,
  setDate,
  setDeletePago,
  deletePago,
  currentPayment,
}) {
  return (
    <>
      {modalPago && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 max-h-[80vh] overflow-y-auto">
            <div className="space-y-4">
              {/* Título */}
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-gray-900 text-center">
                  {deletePago
                    ? "Deseas eliminar este pago?"
                    : "Agregar un nuevo pago"}
                </h3>
                <button
                  onClick={() => {
                    setModalPago(false);
                    setDeletePago(false);
                  }}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {deletePago ? (
                ""
              ) : (
                <div>
                  <label
                    htmlFor="date"
                    className="block mb-2 text-sm font-medium text-gray-700"
                  >
                    Fecha de pago:
                  </label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  />
                </div>
              )}

              <button
                onClick={() => handleUpdatePayment(currentPayment)}
                disabled={isSaving}
                className={`${
                  deletePago
                    ? "from-red-500 to-red-600"
                    : "from-blue-500 to-blue-600"
                } flex-1 px-4 py-3 bg-gradient-to-r w-full  text-white rounded-lg font-medium  transition-all disabled:opacity-50 flex items-center justify-center gap-2`}
              >
                {isSaving ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                    <span>{deletePago ? "Eliminando..." : "Guardando..."}</span>
                  </>
                ) : (
                  <>
                    <span>{deletePago ? "Eliminar" : "Guardar"}</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ModalPago;
